module.exports = __webpack_public_path__ + "img/NAJU_Klammer.4083f1d7.png";